module.exports = __webpack_public_path__ + "static/img/close.83cc6702.svg";